import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showMultiFactorAuthenticationPopupAction } from '../store/actions';

export const useMultiFactorAuthenticationPopup = () => {
    const dispatch = useDispatch();

    return useCallback(
        popupData => {
            // needed for Caxia retail project
            if (window.customMultiFactorAuthLogic) {
                window.customMultiFactorAuthLogic({
                    onSuccess: popupData.onSuccess, onCancel: popupData.onCancel
                });
            } else {
                dispatch(showMultiFactorAuthenticationPopupAction(popupData));
            }
        },
        [dispatch]
    );
};
